export const stripTrailingSlash = (str) => {
    return str.replace(/\/$/, '');
};
